import { Game } from "@mblinkov/whats-missing";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Config from "../../Config";
import { useWindowDimensions } from "../../utils";
import PersonalDefaultPage from "../personal/PersonalDefaultPage";

export default function WhatsMissing() {
  const navigate = useNavigate();
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();

  // Fallback значения если useWindowDimensions вернул undefined
  const width =
    screenWidth || (typeof window !== "undefined" ? window.innerWidth : 1366);
  const height =
    screenHeight || (typeof window !== "undefined" ? window.innerHeight : 768);

  // Получаем реальное разрешение экрана для правильной категоризации
  // Это важно при системном zoom Windows (например, 150%)
  const realScreenWidth =
    typeof window !== "undefined" && window.screen
      ? window.screen.width
      : width;

  // ✅ Улучшенная логика размеров игры
  let gameCubeSize = 400;

  if (width < 768) {
    // Мобилки: используем почти всю ширину с небольшими отступами
    gameCubeSize = width - 20;
  } else if (width < 1200) {
    // Планшеты и маленькие ноутбуки: адаптивный размер
    gameCubeSize = Math.min(width, height) - 60;
  } else if (realScreenWidth <= 1400) {
    // Для разрешений до 1400px используем ту же логику что и для десктопов
    // но с правильным учетом всех отступов
    const paddingTop = width > 1420 ? 25 : 68;
    const availableHeight = height - paddingTop - 25 - 25;
    // ✅ ИСПРАВЛЕНО: минимум 600px чтобы интерфейс влазил даже при маленькой высоте браузера
    gameCubeSize = Math.max(Math.min(1000, availableHeight), 600);
  } else {
    // Десктопы: фиксированный комфортный размер
    gameCubeSize = Math.min(1000, height - 100);
  }

  // ✅ Минимальные ограничения для читаемости
  gameCubeSize = Math.max(gameCubeSize, 320); // минимум для мобилок
  gameCubeSize = Math.min(gameCubeSize, 1200); // максимум для больших экранов

  useEffect(() => {
    let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod";
    axios
      .get(backendAddr)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === "not_paid") {
            navigate("/billing/");
          }
        }
      })
      .catch((err) => {
        console.warn("Ошибка проверки подписки в БД! ", err);
      });
  }, [navigate]);

  return (
    <PersonalDefaultPage>
      <Game
        gameCubeSize={gameCubeSize}
        screenHeight={height}
        screenWidth={width}
        showLogo={true}
      />
    </PersonalDefaultPage>
  );
}
